export const SUBSTANCE_SELECTED = 'SubstanceProportionForm/SUBSTANCE_SELECTED';
export const SAVE_SUBSTANCE_PROPORTION_FORM = 'SubstanceProportionForm/SAVE_SUBSTANCE_PROPORTION_FORM';

export const FETCH_SELECTED_SUBSTANCE_DETAILS = 'SubstanceProportionForm/FETCH_SELECTED_SUBSTANCE_DETAILS';
